import React, { useEffect } from 'react';
import { Modal } from '../modal';
import { Button, Flex } from '@mantine/core';
import { ReactComponent as Trash } from './trash.svg';
import { useIntl } from 'react-intl';
import { theme } from '../globalStyle/global-styles';
import { useNavigate } from 'react-router-dom';
import { DeleteButtonContainer } from './styles';
import { AxiosResponse } from 'axios';
import { CustomModal } from '../customModal';

interface DeleteModalProps {
  showDeleteModal: boolean;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
  navigateTo?: string;
  submit: any;
  headerText?: string;
}

export function DeleteModal({
  showDeleteModal,
  setShowDeleteModal,
  message,
  submit,
  navigateTo = '',
  headerText,
}: DeleteModalProps) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  useEffect(() => {
    if (navigateTo) {
      const time = setTimeout(() => {
        navigate(navigateTo);
      }, 2000);
      return () => clearTimeout(time);
    }
  }, [navigateTo]);

  const handleSubmit = async () => {
    setShowDeleteModal(false);
    await submit();
  };

  return (
    <CustomModal
      opened={showDeleteModal}
      size="sm"
      onClose={() => setShowDeleteModal(false)}
      withCloseButton={false}
      closeOnEscape={false}
      header={
        headerText
          ? formatMessage({ id: `${headerText}` })
          : formatMessage({ id: `${message}` })
      }
    >
      <Flex
        py={'16px'}
        px={{ base: '30px', md: '40px' }}
        justify={'center'}
        align={'center'}
        direction={'column'}
        gap={32}
      >
        <Trash />
        <p
          style={{
            fontSize: '16px',
            fontWeight: '600',
            fontFamily: `${theme.fonts.Regular}`,
            textAlign: 'center',
          }}
        >
          {formatMessage({ id: `${message}` })}
        </p>

        <DeleteButtonContainer>
          <Button type="button" onClick={handleSubmit}>
            {formatMessage({ id: 'confirm' })}
          </Button>
          <Button type="reset" onClick={() => setShowDeleteModal(false)}>
            {`${formatMessage({ id: 'cancel' })}`}
          </Button>
        </DeleteButtonContainer>
      </Flex>
    </CustomModal>
  );
}
